export default "__VITE_PUBLIC_ASSET__b9e19bc2__"